import { Loader } from 'rsuite';

// Keep refresh feedback separate from header content so counts stay in place.
export default function DashboardSection({ id, title, icon, description, className = '', failedSources = [], errorMessage = 'Some counts could not be loaded.', refreshing = false, onRetry, children }) {
	const headingId = `dashboard-section-${id}`;
	const descriptionId = `${headingId}-description`;
	const hasError = failedSources.length > 0;

	return (
		<section className={`dashboard-section ${className}`} aria-labelledby={headingId} aria-describedby={description ? descriptionId : undefined} aria-busy={refreshing || undefined}>
			<header className="dashboard-section__header">
				<div className="dashboard-section__heading">
					{icon && <span className="dashboard-section__icon" aria-hidden="true">{icon}</span>}
					<div className="dashboard-section__intro">
						<h2 id={headingId} className="dashboard-section__title">{title}</h2>
						{description && <p id={descriptionId} className="dashboard-section__description">{description}</p>}
					</div>
				</div>
				<div className="dashboard-section__status" aria-live="polite">
					{hasError ? (
						<span className="dashboard-section__error">
							{errorMessage}
							<button type="button" className="dashboard-section__retry" onClick={() => failedSources.forEach((key) => onRetry?.(key))}>
								Retry
							</button>
						</span>
					) : null}
				</div>
			</header>
			{refreshing && !hasError && (
				<span className="dashboard-section__updating" role="status">
					<Loader size="xs" aria-hidden="true" />
					<span className="dashboard-sr-only">Updating counts</span>
				</span>
			)}
			<div className="dashboard-section__grid">{children}</div>
		</section>
	);
}
